import { PropertySet } from "../Item/PropertySet"

export function CreatePropertySet() {
  return <PropertySet />
}